module.exports = __webpack_public_path__ + "static/img/001.0338200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/001.png
// module id = bUzH
// module chunks = 1